<template>
<section :class="{'contfluiddatacss' :contfluidatatheme==='contfluiddatacss'}">
   <div class="divdesc">
        <img :src="contfluiddata.confluidimage" class="sectionimage" style="max-height: 400px;">
        <div class="col col-sm col-md">
            <div class="boxdata">
                <div  class="slide-info ">
                    <div  class="spantext">
                        <div class="titleformat">{{ contfluiddata.confshortdesc }}</div>
                        <div v-html="contfluiddata.confdesc" class="desctext"></div>
                        <router-link :to="{path: contfluiddata.confluidlink}"><div class="linktext">{{ contfluiddata.confluidlinkname }} <i class="fa-solid fa-square-arrow-up-right linkarrow"></i></div></router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>  

    </template>
    
    <script>
 
    export default {
      props: ['contfluiddata', 'contfluidatatheme'],
        data() {
            return {
    
            }
        },
      
    }
    </script>
    
<style scoped>

img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #003;
  }
.sectioncontrol {
     height: 100%;
     margin-top: 50px;
     margin-bottom: 40px;
}
.sectionimage {
    height: 100%;
    width: 100%;
    z-index: 1;
}
.boxdata{
    position: relative;
    width: 350px;
    height: auto;
    margin-top: -280px;
    margin-left: 180px;
    border: solid orange thick;
    z-index: 1;
}
.slide-info {
    background-color: white;
    position: relative;
    margin-top: 10px;
    margin-left: 10px;
    width: 350px;
    height:290px;
    border-radius: 5px;
}
.spantext {
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 20px;
    padding-bottom: 10px;
    
}
.linkspantext{
    padding-bottom: 20px;
  }
.desctext{
    font-size: 18px;
}
.divdesc {
    padding-top: 100px;
    padding-bottom: 100px;
    background-color: #003;
}

.titleformat{
    font-size: 24px;
    font-weight: bold;
    padding-bottom:30px;
}
.linktext {
    text-decoration: none;
    font-weight: bold;
    float: right;
    color: orangered;
  }
  .linkarrow {
    padding-left: 10px;
    font-size: 26px;
    color: orangered;
  }
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
    .sectionimage {
        width: 100hv;
        height: 140px;
    }
    .boxdata{
        position: relative;
        width: 330px;
        height: auto;
        margin-top: 80px;
        margin-left: auto;
        margin-right: auto;
    }
    .slide-info {
        background-color: white;;
        margin-top: auto;
        margin-right: auto;
        width: auto;
        height:290px;
        border-radius: 5px;
    }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {

 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
 .boxdata {
    margin-top: -150px;
 }
 }
 
 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {
    .sectionimage {
        width: 100%;
        max-height: 600px;
    }
 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
    
 } 
</style>